/**
 * BackOffice Auth API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Returned by login / 2fa/verify / refresh / impersonate. Contains tokens only; the client fetches the user via GET /auth/me.
 */
export interface TokenResponse {
  /**
   * Signed JWT.
   */
  accessToken: string;
  refreshToken: string;
  tokenType: TokenResponseTokenTypeEnum;
  /**
   * Access-token lifetime in seconds.
   */
  expiresIn: number;
}
export enum TokenResponseTokenTypeEnum {
  Bearer = "Bearer",
}
